import socket from '@/plugins/socket'

export default {
  namespaced: true,
  state: {
    list: [],
    filtered: []
  },
  mutations: {
    init: (state, datas) => { state.list = datas.sort((a, b) => a.name.localeCompare(b.name)) },
    filtered: (state, datas) => {
      datas = datas.sort((a, b) => a.order - b.order)
      state.filtered = [...new Set(datas.map(item => item.groupTypeId))]
    }
  },
  actions: {
    init (state) { socket.get('SportSportGrouptype', 'Sport/GroupType/init') },
    set (state, data) {
      state.state.filtered = []

      if (data.sportId > 0 || data.competitionsId > 0) {
        const parameters = { join: ['SportSportGroup.roundId'], joinr: [], include: [{ column: 'groupTypeId' }] }

        if (data.roundsTypeId > 0) {
          if (data.roundsTypeId.length === 1) {
            parameters['SportSportRound.roundTypeId'] = data.roundsTypeId[0]
          } else {
            parameters['SportSportRound.roundTypeId'] = {
              column: 'SportSportRound.roundTypeId',
              operator: 'in',
              value: data.roundsTypeId
            }
          }
        }

        // competition
        if (data.seasonId > 0 || data.competitionsId.length > 0) {
          parameters.join.push('SportSportRound.competitionSeasonId')

          if (data.seasonId > 0) {
            parameters['SportSportCompetitionseason.seasonId'] = data.seasonId
          }

          if (data.competitionsId.length === 1) {
            parameters['SportSportCompetitionseason.competitionId'] = data.competitionsId[0]
          } else if (data.competitionsId.length > 1) {
            parameters['SportSportCompetitionseason.competitionId'] = {
              column: 'SportSportCompetitionseason.competitionId',
              operator: 'in',
              value: data.competitionsId
            }
          }
        }

        // discipline
        if (data.eventUnitsId > 0) {
          parameters['SportSportRound.eventUnitId'] = {
            value: data.eventUnitsId,
            operator: 'in'
          }
        } else {
          parameters.join.push('SportSportRound.eventUnitId')

          if (data.categoryId > 0) {
            parameters['SportSportEventunit.categoryId'] = data.categoryId
          }

          if (data.eventId > 0) {
            parameters['SportSportEventunit.eventId'] = data.eventId
          } else if (data.disciplineId > 0) {
            parameters['SportSportEvent.disciplineId'] = data.disciplineId
            parameters.join.push('SportSportEventunit.eventId')
          } else if (data.sportId > 0) {
            parameters['SportSportDiscipline.sportId'] = data.sportId
            parameters.join.push('SportSportEventunit.eventId')
            parameters.join.push('SportSportEvent.disciplineId')
          }

          if (data.genderId > 0) {
            parameters['SportSportEventunit.genderId'] = data.genderId
          }

          // todo : Classification
        }

        socket.get('SportSportGroup', 'Sport/GroupType/filtered', parameters)
      }
    }
  },
  getters: {
    list: (state) => state.list,
    filtered: (state) => state.filtered,
    get: (state) => (id) => state.list.find(item => item.id === id)
  }
}
